import React, { useContext } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Text, RedStar } from "@dhxete/text";
import { useAppContext } from "../Context";

const RequiredDisclaimer = ({
  className,
  id
}) => {
  const {
    state: {
      langStrings
    }
  } = useAppContext();
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    id: id
  }, /*#__PURE__*/React.createElement(RedStar, null), /*#__PURE__*/React.createElement(Text, {
    variant: "caption"
  }, langStrings.buttons.requiredLabel));
};

RequiredDisclaimer.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string
};
export default styled(RequiredDisclaimer)`
  display: block;
  margin-top: 30px;
  margin-bottom: 30px;
`;